var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t("previewApplicationPageStrings.handlingCompleted", [_vm.handledOrgName]))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }